<template>
  <div id="app" class="App">
    <FullViewLoading v-if="isWaitingForSaleServicePointData" />
    <section>
      <TheHeader :language="paymentLanguage" :logoImage="brandLogo" />
      <el-main role="main" class="App__main-view">
        <router-view></router-view>
      </el-main>
      <TheFooter v-if="!isWaitingForSaleServicePointData && shouldShowFooter" 
        :colors="brandColors"
      />
    </section>    
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ManageTokenService from '@/services/ManageTokenService';
import TheHeader from '@/components/Common/TheHeader';
import TheFooter from '@/components/Common/TheFooter';
import FullViewLoading from '@/components/Common/FullViewLoading';

export default {
  name: 'app',
  components: {
    TheHeader, TheFooter, FullViewLoading,
  },
  computed: {
    ...mapGetters(['paymentLanguage', 'gatewayUrl', 'brandLogo', 'isWaitingForSaleServicePointData', 'brandColors']),
    shouldShowFooter() {
      // return ['pay'].includes(this.$route.name);
      return true;
    },
  },
  watch: {
    gatewayUrl(url) {
      if (url) {
        ManageTokenService.removeTokenFromStorage();
        window.location.href = url;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .App
    width: 100%
    height: 100%
    &__main-view
      width: 100%
      margin: auto
      max-width: 1280px
      padding: 135px 40px 30px 40px !important
      background: url('~/static/img/background.png') no-repeat scroll center bottom white
      background-size: cover
      @include breakpoint(xsmall)
        padding: 70px 15px 30px 15px !important
        overflow: hidden  
</style>



// WEBPACK FOOTER //
// src/App.vue